interface SelectDaysNumberProps {
    selectedDaysNumber: DefaultDaysNumber;  
    setSelectedDaysNumber: (value: DefaultDaysNumber) => void;    
}
  
  function SelectDaysNumber({
    selectedDaysNumber,
    setSelectedDaysNumber,
  }: SelectDaysNumberProps) {
    const list: Array<DefaultDaysNumber> = [1, 2];
    return (
      <div>
        <select
          value={selectedDaysNumber}
          onChange={(e) => {
              setSelectedDaysNumber(+e.target.value as DefaultDaysNumber);
          }}
          className='mr-2 lg:mr-2 p-1 text-[14px] rounded border bg-white dark:bg-gray-700 text-gray-900 dark:text-white h-[32px] w-[60px]'
        >
          {list.map((item) => (
            <option key={item} value={item}>
              {item}
            </option>
          ))}
        </select>
      </div>
    );
  }
  
  export default SelectDaysNumber;